// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_r3-5";
export var filledCircle = "_r3-4";
export var historyEntry = "_r3-3";
export var messageSideLeft = "_r3-1";
export var messageSideRight = "_r3-2";
export var orderTrackingCarouselWrapper = "_r3-6";
export var orderTrackingInfoContainer = "_r3-0";